<script setup lang="ts">
export type StockInStore = {
  name: string
  url: string
  warehouseId: number[]
  stock?: any
}

const props = defineProps<{
  data: any
}>()

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const storeData = computed<any[]>(() => layoutData.value?.storePages?.urls || [])

const stores = computed<StockInStore[]>(() => {
  return storeData.value.map((page: any) => {
    return {
      name: page.label,
      url: page.url,
      warehouseId: page.filters.find((item: any) => item.key === 'WarehouseID')?.values?.[0]?.split(',')?.map((v: string) => v.trim()) || [],
    }
  })
})

const storesWithStock = computed<StockInStore[]>(() => {
  return stores.value.map((page: any) => {
    const warehouseStock = Array.isArray(props.data?.warehouse_stock) ? props.data?.warehouse_stock : [props.data?.warehouse_stock || {}]
    return {
      ...page,
      stock: warehouseStock.find((ws: any) => page.warehouseId.includes(ws.warehouse_nr)),
    }
  }).filter((item: { stock: any | null }) => item.stock)
})
</script>

<template>
  <div
    v-if="stores.length"
    class="pdp__view-in-store"
  >
    <AppLink
      v-if="stores.length === 1"
      :to="stores?.[0]?.url || '/'"
      class="view-in-store__cta view-in-store__button"
    >
      <Icon
        name="icon:location-empty"
        class="icon icon--empty"
        aria-hidden="true"
      />
      <span>{{ $t('Te zien in de winkel. Kom proefzitten') }}</span>
    </AppLink>
    <div v-else-if="storesWithStock.length">
      <h3>Dit artikel is te zien in onze showroom in:</h3>
      <ul>
        <li
          v-for="store in storesWithStock"
          :key="store.url"
        >
          <AppLink :to="store.url">
            {{ store.name }}
          </AppLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style>
 @import url('~layers/app/components/Product/ViewInStore.css');
</style>
